<ng-container *ngIf="mAction.data != null">
	<ng-container *ngFor="let data of mAction.data">
	
		<app-instance-data-infrastructure
			[data]="data"
			>
		</app-instance-data-infrastructure>
		
	</ng-container>
</ng-container>